import React, { useState } from 'react'
import { Select, useToast } from '@chakra-ui/react'
import { useScoreStore } from '../../store/scoreStore'
import ScoreService from '../../API/ScoreService'

function CollectingScoresTag({siteId, pointData}) {
    const toast = useToast()
    const tags = useScoreStore(state => state.tags)
    const updateTag = useScoreStore(state => state.updateScoreTag)
    const [isLoading, setIsLoading] = useState(false)

    const updateTagRequest = (tagId) => {
        toast.promise(
            ScoreService.updateScoreTag(siteId, tagId, pointData.class_type_id),
            {
                success: (response) => {
                    updateTag(siteId, pointData.id, response.data)
                    setIsLoading(false)
                    return { title: 'Тег изменён' }
                },
                error: () => {
                    setIsLoading(false)
                    return { title: 'Не удалось изменить тег' }
                },
                loading: { title: 'Изменение тега...', position: 'top' }
            }
        )
    }

    const resetTagRequest = () => {
        toast.promise(
            ScoreService.resetScoreTag(siteId, pointData.class_type_id),
            {
                success: () => {
                    updateTag(siteId, pointData.id, null)
                    setIsLoading(false)
                    return { title: 'Тег удалён' }
                },
                error: () => {
                    setIsLoading(false)
                    return { title: 'Не удалось удалить тег' }
                },
                loading: { title: 'Удаление тега...', position: 'top' }
            }
        )
    }

    const onChange = async (e) => {
        const tagId = Number(e.target.value)
        setIsLoading(true)
        if (tagId)
            updateTagRequest(tagId)
        else
            resetTagRequest()
    }

    return (
        <Select
            disabled={isLoading}
            size='xs'
            minW='200px'
            placeholder='-'
            value={pointData?.tag?.tag_id || pointData?.tag?.id || '-'}
            onChange={onChange}
        >
            {tags.map(tag => (
                <option value={tag?.tag_id || tag.id} key={tag.id}>
                    {tag.title}
                </option>
            ))}
        </Select>
    )
}

export default CollectingScoresTag
